import React, { useEffect, useContext, useReducer } from 'react';
import reducer from '../reducers/order_reducer';
import {
  UPDATE_SHIPPING_DETAILS,
  GET_ORDERS_BEGIN,
  GET_ORDERS_SUCCESS,
  GET_ORDERS_ERROR,
  UPDATE_PAYMENT_STATUS
} from '../actions';
import { useUserContext } from './user_context';
import { useCartContext } from './cart_context';
import { toast } from 'react-toastify';
import axios from 'axios';
import { get_order_url, create_order_url } from '../utils/constants';

const initialState = {
  orders_loading: false,
  orders_error: false,
  paymentMethod: null, 
  orders: [],
  shipping: {
    name: '',
    address: {
      line1: '',
      postal_code: '',
      city: '',
      state: '',
      country: '',
    },
  },
};

const OrderContext = React.createContext();

export const OrderProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { currentUser } = useUserContext();
  const { cart, total_amount, shipping_fee, couponDiscount } = useCartContext();

  const fetchOrders = async (url) => {
    dispatch({ type: GET_ORDERS_BEGIN });
    try {
      const response = await axios.post(url, {
        email: currentUser.email,
      });
      const orders = response.data;
      dispatch({ type: GET_ORDERS_SUCCESS, payload: orders.data });
    } catch (error) {
      dispatch({ type: GET_ORDERS_ERROR });
    }
  };

  const placeOrder = async (paymentId, onlinePaymentMethod) => {
    const shippingInfo = {
      address: state.shipping.address.line1,
      city: state.shipping.address.city,
      state: state.shipping.address.state,
      country: state.shipping.address.country,
      pinCode: state.shipping.address.postal_code,
      phoneNumber: state.shipping.phone_number,
    };
    const orderItems = cart.map((item) => {
      return {
        name: item.name,
        price: Math.round(item.price),
        quantity: item.amount,
        image: item.image,
      
        product: item.id,
        tax:Math.round(item.taxPrice),
       
        weight:item.productWeight,
        code:item?.code
      };
    });

   
    const paymentInfo = {
      id: "",
      status: 'online',
      onlinePaymentMethod:"hdfc",
    };
    

    const body = {
      name: state.shipping.name,
      email: currentUser?.email,
      phoneNumber: currentUser?.phoneNumber,
      shippingInfo,
      orderItems,
      paymentInfo,
      shippingPrice: shipping_fee,
      discountPrice:couponDiscount

    };
    try {
      const response = await axios.post(create_order_url, body);
      toast.success('Order placed');

      const userid= currentUser.id
      await axios.put(`${process.env.REACT_APP_BACKEND_HOST}/api/user/addorder/${userid}`, {id: response.data.data.id});
      return response.data.data

    } catch (error) {
      toast.error(error.message);
    }
  };

  const updateShipping = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    dispatch({ type: UPDATE_SHIPPING_DETAILS, payload: { name, value } });
  };

  const updatePaymentMethod = (paymentMethod) => {
    dispatch({ type: UPDATE_PAYMENT_STATUS, payload: paymentMethod });
  };

  const refetchOrders = () => {
     const userid = currentUser?.id;
     fetchOrders(`${get_order_url}/${userid}`);
  };

  useEffect(() => {
    const userid=currentUser?.id
    fetchOrders(`${get_order_url}/${userid}`);
    // eslint-disable-next-line
  }, [currentUser, cart]);

  return (
    <OrderContext.Provider value={{ ...state, updateShipping, placeOrder, refetchOrders, updatePaymentMethod }}>
      {children}
    </OrderContext.Provider>
  );
};
// make sure use
export const useOrderContext = () => {
  return useContext(OrderContext);
};
